import { render, staticRenderFns } from "./CreateTags.vue?vue&type=template&id=77cdf934&scoped=true"
import script from "./CreateTags.vue?vue&type=script&lang=js"
export * from "./CreateTags.vue?vue&type=script&lang=js"
import style0 from "./CreateTags.vue?vue&type=style&index=0&id=77cdf934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cdf934",
  null
  
)

export default component.exports